import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { Alert } from "@mapmycustomers/ui";

import ButtonLink from "@app/component/ButtonLink";
import useMapView from "@app/component/view/utils/useMapView";
import { MAP_ENTITY_TYPES } from "@app/util/map/consts";
import { getEntityTypeDisplayName } from "@app/util/ui";

interface Props {
  onHide?: () => void;
  visibleEntities: EntityTypesSupportedByMapsPage[];
}

const HiddenEntitiesWarning: React.FC<Props> = ({ onHide, visibleEntities }) => {
  const intl = useIntl();
  const { updateViewStateAndFetch } = useMapView();

  const hiddenEntities = MAP_ENTITY_TYPES.filter(
    (entityType) => !visibleEntities.includes(entityType)
  );

  const handleClose = useCallback(() => {
    onHide?.();
    updateViewStateAndFetch({ request: { visibleEntities: MAP_ENTITY_TYPES } });
  }, [onHide, updateViewStateAndFetch]);

  if (!hiddenEntities.length) {
    return null;
  }

  return (
    <Alert
      action={
        <ButtonLink onClick={handleClose}>
          {intl.formatMessage({
            id: "map.filters.hiddenEntitiesAlert.showAnyway",
            defaultMessage: "Show Anyway",
            description: "Alert close button - shows other entities",
          })}
        </ButtonLink>
      }
      message={intl.formatMessage(
        {
          id: "map.filters.hiddenEntitiesAlert",
          defaultMessage: "{entityList} are now hidden on the map",
          description:
            "An alert show when user adds filter for one of entities, other are hidden then",
        },
        {
          entityList: intl.formatList(
            hiddenEntities.map((entityType) =>
              getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true })
            ),
            { type: "conjunction" }
          ),
        }
      )}
      type="info"
    />
  );
};

export default HiddenEntitiesWarning;
